import { ROLE_ID } from '../constants/roles';

export function getRoleId(roleName: string): number {
  const roleMap: Record<string, number> = {
    admin: ROLE_ID.ADMIN,
    employee: ROLE_ID.EMPLOYEE,
  };
  return roleMap[roleName.toLowerCase()];
}
